import React, { createContext, useEffect, useState } from "react";
import { getSortedCollection } from "sprint-common-web";

import { GetAirlinesLookupResponse } from "../../api/admin-api/GetAirlinesLookupResponse";
import { useAdminApi } from "../../api/admin-api/useAdminApi";
import { Airline, mapToAirline } from "../../types/Airline";

interface IAirlinesDataContext {
    airlines: Airline[];
    isLoading: boolean;
}

export const AirlinesDataContext = createContext<IAirlinesDataContext>({
    airlines: [],
    isLoading: true
});

type AirlinesDataProviderProps = React.PropsWithChildren<unknown>;

export const AirlinesDataProvider: React.FunctionComponent<AirlinesDataProviderProps> = ({
    children
}: AirlinesDataProviderProps) => {
    const [airlines, setAirlines] = useState<Airline[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const { getAirlinesLookup } = useAdminApi();

    useEffect(() => {
        getAirlinesLookup()
            .then((response: GetAirlinesLookupResponse) => {
                const items = response.items.map(mapToAirline);
                const sortedItems = getSortedCollection(items, "name");

                setAirlines(sortedItems);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return <AirlinesDataContext.Provider value={{ airlines, isLoading }}>{children}</AirlinesDataContext.Provider>;
};
